import * as yup from 'yup'

export const schema = yup.object({
	title: yup
		.string()
		.required('Title is required')
		.max(50, 'Title must be at most 50 characters'),

	body: yup.string().max(150, 'Body must be at most 150 characters'),

	contentType: yup
		.mixed<
			| 'category'
			| 'author'
			| 'soundtrack'
			| 'rambam'
			| 'dailyStudies'
			| 'suggestion'
			| 'newCycle'
			| 'home'
			| 'versionUpdate'
			| 'empty'
		>()
		.required('Content type is required'),

	contentId: yup
		.number()
		.typeError('Content ID must be a number')
		.when('contentType', {
			is: (val: string) => {
				return val !== 'home' && val !== 'empty' && val !== 'versionUpdate'
			},
			then: schema => schema.required('Content ID is required'),
			otherwise: schema => schema.notRequired().nullable(),
		}),

	languageSelect: yup.string().when('contentType', {
		is: (val: string) => {
			return val === 'home'
		},
		then: schema => schema.required('Language required'),
		otherwise: schema => schema.notRequired().nullable(),
	}),
})

export type ValidationSchemaType = yup.InferType<typeof schema>
